import { Button, ButtonProps } from '@chakra-ui/react';
import { rem } from 'polished';
import { forwardRef } from 'react';

export const ProminentButtonContainer = forwardRef((props: ButtonProps, ref) => (
  <Button
    ref={ref}
    variant=""
    height="auto"
    rounded="radius.8"
    {...props}
    backgroundColor="black"
    backgroundImage="linear-gradient(103.61deg, #131313 25.73%, #4B4B4B 108.9%)"
    padding={rem(3)} // leaves space for border
  />
));
